import { UserRolesEnum } from '@shared/constants/auth.constants';

import type { KnowledgeBaseCapabilities, KnowledgeBaseRole } from './types';

export const getKnowledgeBaseCapabilities = (
  role: KnowledgeBaseRole,
  isSquadCampaign: boolean,
): KnowledgeBaseCapabilities => {
  const canView = role === UserRolesEnum.ADMIN || role === UserRolesEnum.VIEWER;
  const canManageFiles = role === UserRolesEnum.ADMIN;

  return {
    canView,
    canManageFiles,
    canManageAssignments: canManageFiles && isSquadCampaign,
  };
};
